import React from 'react'
import {useTranslation} from 'react-i18next'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {Box, Theme} from '@mui/material'
import {PGButton} from '@progynyglobal/pg-ui-library'
import {makeStyles} from 'tss-react/mui'

interface CancelConsultationProps {
  cancelUrl: string
  onBack: () => void
}

const CancelConsultation: React.FC<CancelConsultationProps> = ({
  cancelUrl,
  onBack,
}) => {
  const {t} = useTranslation()
  const {classes} = useStyles()
  const iframeSrc = React.useMemo(() => {
    if (!cancelUrl) {
      return ''
    }

    try {
      const url = new URL(cancelUrl)
      url.searchParams.set('theme', 'light')
      return url.toString()
    } catch (error) {
      const separator = cancelUrl.includes('?') ? '&' : '?'
      return `${cancelUrl}${separator}theme=light`
    }
  }, [cancelUrl])

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <PGButton
          variant='text'
          label={t('common_back')}
          onClick={onBack}
          startIcon={<ArrowBackIcon />}
        />
      </Box>
      <Box className={classes.iframeWrapper}>
        <iframe
          src={iframeSrc}
          title={t('consultations_cancel_modal_iframe_title')}
          className={classes.iframe}
        />
      </Box>
    </Box>
  )
}

export default CancelConsultation

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    gap: theme.spacing(3),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  iframeWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '1100px',
  },
  iframe: {
    width: '100%',
    minHeight: '1000px',
    border: 'none',
    borderRadius: theme.spacing(1),
    boxShadow: '0px 3px 16px rgba(190, 192, 198, 0.24)',
  },
}))
